import React from 'react'
import '../Footer/Footer.css'
import Appstore from '../Images/appstore-icon.png'
import Playstore from '../Images/playstore-icon.png'
import { FaWhatsapp, FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";



export const Footer = () => {
  return (
    <div className='footer'>
      <div className="content">

        <div className="footer-para">
          <h2>Fresh2Day</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Velit consequatur sint esse vero hic aut labore porro nemo incidunt inventore laboriosam enim, quam quos natus harum ea excepturi nisi ad?</p>
          <div className='apps'>
            <img src={Appstore} alt="" />
            <img src={Playstore} alt="" />
          </div>
          <div className="social-icon">
            <i><FaWhatsapp /></i>
            <i><FaFacebook /></i>
            <i><FaInstagram /></i>
            <i><FaTwitter /></i>
          </div>
        </div>

        <div className="list">
          <ul><h5>Ouick Links</h5><li>Home</li><li>About us</li><li>Delivery Partner</li><li>Privacy Policy</li><li>Terms and Conditions</li><li>Refund Policy</li></ul>
        </div>

        <div className="list">
          <ul><h5>Locations</h5><li>Chennai</li><li>Madurai</li><li>Kovai</li><li>Salem</li><li>Trichy</li></ul>
        </div>

        <div className="list">
          <ul><h5>Find us?</h5><li>Sign In</li><li>Partners</li><li>Contact</li><li>FAQ's</li><li>Compare</li></ul>
        </div>
      </div>
      <div className="copyright">
        <p>Copyright &copy; 2023. All Rights Reserved.</p>
        <p>Designed by Mathankumar.S</p>
      </div>
    </div>
  )
}
